import React, { useEffect, useState } from 'react';
import { useLowBandwidth } from '../contexts/LowBandwidthContext';
import { Wifi } from 'lucide-react';

const LowBandwidthIndicator = () => {
  const { isLowBandwidth } = useLowBandwidth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isLowBandwidth) {
      setShow(true);
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => setShow(false), 5000);
      return () => clearTimeout(timer);
    } else {
      setShow(false);
    }
  }, [isLowBandwidth]);

  if (!show) return null;

  return (
    <div className="low-bandwidth-indicator">
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Wifi size={14} />
        <span style={{ fontWeight: '500' }}>Low Bandwidth Mode Active</span>
      </div>
    </div>
  );
};

export default LowBandwidthIndicator;
